export default {
    v: '3',
    key: 'AIzaSyAo_ZkxtwqpS5_PN_mH4RC7IBts64C2Vio',
    libraries: 'places',
};
